import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIDialogContent(theme: Theme): Components['MuiDialogContent'] {
  return {
    styleOverrides: {
      root: {
        padding: theme.spacing(6),
        color: theme.palette.text.primary,
        borderTop: 0,
        borderBottom: 0,
      },
    },
  };
}
